export default __webpack_public_path__ + "media/zurb/img/services/design-insight/design-insight-icon-694541a83b7b2d4ca9aa2732d5dcf8f6.svg";